/**
 * @desc 财务画像-基础信息-公司基本信息
 */
import style from '../common/common.scss';
import React, { PureComponent } from 'react';
import GroupBox from '../../../common/groupBox/GroupBox';
import AntdTable from '../../common/AntdTable';
import { Row, Col, Spin } from 'antd';
import { isNotEmpty } from '../../../../utils/util';
import { fieldAnomaly } from '../../../../utils/formatter';
import { commonRequest } from '../../common/commons';
import { companyBeseInfo, businessChange } from '../../../../services/financialPicture/baseInfo';
import NoData from '../../../common/noData/NoData';
import Ellips from '../../../common/ellipsisAndTooltip/EllipsisAndTooltip';

export default class BusinessInformation extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            companyInfoData: {},
            loading: false
        };
    }

    componentDidMount() {
        this.companyTableInfo();
    }

    // 公司基本信息
    companyTableInfo = () => {
        this.setState({
            loading: true
        });
        companyBeseInfo(commonRequest()).then(data => {
            data = data || {};
            this.setState({
                loading: false,
                companyInfoData: data
            });
        }).finally(() => {
            this.setState({
                loading: false
            });
        });
    };

    baseInfoData = (companyInfoData) => {
        return [
            {
                title: '公司名称',
                dataIndex: fieldAnomaly(companyInfoData.companyName),
                titleTwo: '曾用名',
                name: <Ellips text={fieldAnomaly(companyInfoData.historyName)} />,
                key: '1'
            },
            {
                title: '所属行业',
                dataIndex: fieldAnomaly(companyInfoData.companyIndustry),
                titleTwo: '注册资本',
                name: fieldAnomaly(companyInfoData.regcap),
                key: '2'
            },
            {
                title: '办公地址',
                dataIndex: <Ellips text={fieldAnomaly(companyInfoData.address)} />,
                titleTwo: '员工总数',
                name: fieldAnomaly(companyInfoData.staffNum),
                key: '3'
            },
            {
                title: '董事长',
                dataIndex: fieldAnomaly(companyInfoData.chairman),
                titleTwo: '总经理',
                name: fieldAnomaly(companyInfoData.manager),
                key: '4'
            },
            {
                title: '实际控制人',
                dataIndex: <Ellips text={fieldAnomaly(companyInfoData.accontroller)} />,
                titleTwo: '所属地域',
                name: fieldAnomaly(companyInfoData.companyCity),
                key: '5'
            },
            {
                title: '主营业务',
                dataIndex: <Ellips text={fieldAnomaly(companyInfoData.operateScope)} />,
                titleTwo: '公司网址',
                name: fieldAnomaly(companyInfoData.homePage),
                key: '6'
            },
            {
                title: '股票代码',
                dataIndex: fieldAnomaly(companyInfoData.stockCode),
                titleTwo: '股票简称',
                name: fieldAnomaly(companyInfoData.stockShort),
                key: '7'
            },
            {
                title: '公司简介',
                dataIndex: <Ellips text={fieldAnomaly(companyInfoData.companyIntroduction)} />,
                titleTwo: '法人代表	',
                name: fieldAnomaly(companyInfoData.frname),
                key: '8'
            },
            {
                title: '电话',
                dataIndex: fieldAnomaly(companyInfoData.phoneNumber),
                titleTwo: <Ellips text={'注册号/统一社会信用代码 '} />,
                name: fieldAnomaly(companyInfoData.regnoOrCreditcode),
                key: '9'
            }
        ];
    };

    getColumns = () => {
        return [
            {
                title: '异常变更',
                dataIndex: 'index',
                width: 370
            },
            {
                title: '变更情况',
                dataIndex: 'change_items',
                render: text => fieldAnomaly(text)
            }
        ];
    };

    render() {
        const { loading, companyInfoData } = this.state;
        return (
            <div>
                <GroupBox title="工商登记" id="business-regist">
                    <ul className={style.commonList}>
                        {
                            loading ? <Spin tip="数据加载中，请稍候……" /> :
                                isNotEmpty(companyInfoData) ?
                                    this.baseInfoData(companyInfoData).map(item =>
                                        <div key={item.key} className={style.oddBg}>
                                            <Row>
                                                <Col span={3}>
                                                    <li className={style.liOddLR}>{item.title}</li>
                                                </Col>
                                                <Col span={9}>
                                                    <li className={style.liOddBolrd}>{item.dataIndex}</li>
                                                </Col>
                                                <Col span={3}>
                                                    <li className={style.liOddLR}>{item.titleTwo}</li>
                                                </Col>
                                                <Col span={9}>
                                                    <li className={style.liOddBolrd}>{item.name}</li>
                                                </Col>
                                            </Row>
                                        </div>
                                    ) : <NoData />
                        }
                    </ul>
                </GroupBox>
                <AntdTable
                    className="margin-top-40"
                    idName={'business-change'}
                    title={'工商变更'}
                    list={true}
                    requestApi={businessChange}
                    columns={this.getColumns()}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/businessInformation/BusinessInformation.jsx